(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("orderSummaryReport", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/orderSummaryReportView.html",
            controller: ["authService", "frameworkService", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$translate", "$filter", "calendarSettingsService", "DTOptionsBuilder", OrderSummaryReportCtrl],
            controllerAs: "vm"
        };
        function OrderSummaryReportCtrl(authService, frameworkService, $localStorage, $sessionStorage, $timeout, $scope, $state, $translate, $filter, calendarSettingsService, DTOptionsBuilder) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            var all = $translate.instant("common.all");
            vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
            vm.dtInstance = {
                reloadData: function () { }
            };
            vm.dtOptions = {};
            vm.datePickerList = {
                paidDateFrom: false,
                paidDateTo: false
            };
            vm.statuses = [{ "id": 1, "status": "Paid" }, { "id": 2, "status": "Pending" }, { "id": 3, "status": "PartiallyRefunded" }, { "id": 4, "status": "Refunded" }];
            //Date picker Config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.openToggle = calendarSettingsService.openToggle;
            if ($sessionStorage.orderSummaryReportFilters) {
                vm.filters = $sessionStorage.orderSummaryReportFilters;
                if ($sessionStorage.orderSummaryReportFilters.paidDate.fromValue)
                    vm.filters.paidDate.fromValue = new Date($sessionStorage.orderSummaryReportFilters.paidDate.fromValue);
                if ($sessionStorage.orderSummaryReportFilters.paidDate.toValue)
                    vm.filters.paidDate.toValue = new Date($sessionStorage.orderSummaryReportFilters.paidDate.toValue);
            }
            else {
                vm.filters = {
                    orderSeq: { enabled: true, value: "" },
                    paidDate: { enabled: false, fromValue: "", toValue: "" },
                    status: { enabled: true, value: [] }
                };
            }
            vm.reloadTable = function () {
                $timeout(function () {
                    $sessionStorage.orderSummaryReportFilters = vm.filters;
                    vm.dtInstance.reloadData();
                });
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.orderSummaryReportFilters = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                if (vm.filters[filter].hasOwnProperty("value"))
                    vm.refreshFilter(vm.filters[filter].value);
                if (vm.filters[filter].hasOwnProperty("fromValue")) {
                    vm.refreshFilter(vm.filters[filter].fromValue + vm.filters[filter].toValue);
                }
            };
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/reports/orderSummary",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "POST",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[0].search.value = vm.filters.orderSeq.enabled ? vm.filters.orderSeq.value : "";
                    //data.columns[2].search.value = vm.filters.email.enabled ? vm.filters.email.value : "";
                    data.columns[2].search.value = "";
                    if (vm.filters.paidDate.enabled) {
                        var search = "";
                        if (vm.filters.paidDate.fromValue)
                            search = moment(vm.filters.paidDate.fromValue).utc().format("YYYY-MM-DD HH:mm");
                        search = search + "|";
                        if (vm.filters.paidDate.toValue) {
                            search = search + moment(vm.filters.paidDate.toValue).utc().format("YYYY-MM-DD HH:mm");
                        }
                        data.columns[2].search.value = search !== "|" ? search : "";
                    }
                    data.columns[4].search.value = vm.filters.status.enabled ? vm.filters.status.value.join("|") : "";
                }
            })
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("stateSave", false)
                .withOption("order", [0, "asc"])
                .withOption("lengthMenu", [[10, 25, 50, -1], [10, 25, 50, all]])
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDOM("Bfrtip")
                .withPaginationType("full_numbers")
                .withButtons([
                "pageLength",
                {
                    extend: "excelHtml5",
                    exportOptions: {
                        orthogonal: "sort"
                    }
                }
            ])
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": "orderSeq",
                    "render": function (data, type) {
                        if (type === "sort") {
                            return "\u200C" + data;
                        }
                        return data;
                    }
                },
                {
                    "data": "orderType",
                    "class": "text-center",
                    "orderable": false,
                    "render": function (data) {
                        return $translate.instant("common.orderType." + data);
                    }
                },
                {
                    "data": "paidDate",
                    "orderable": false,
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data != null ? moment.utc(data).local().format("MMM D, YYYY") : "";
                    }
                },
                //{
                //	"data": "orderStatus",
                //	"class": "text-center",
                //	"orderable": false,
                //	"render": function (data) {
                //		return $translate.instant("common.orderStatus." + data);
                //	}
                //},
                { "data": "name", "orderable": false },
                { "data": "organizationName", "orderable": false, "visible": vm.organizationEnabled },
                {
                    "data": "paymentStatus",
                    "class": "text-center",
                    "orderable": false,
                    "render": function (data) {
                        return $translate.instant("common.paymentStatus." + data);
                    }
                },
                {
                    "data": "paymentMethod",
                    "class": "text-center",
                    "orderable": false,
                    "render": function (data) {
                        return $translate.instant("common.paymentMethod.learner." + data);
                    }
                },
                { "data": "paymentConfirmationId", "orderable": false },
                {
                    "data": "totalPrice",
                    "class": "text-nowrap text-right",
                    "orderable": false,
                    "render": function (data, _type, full) {
                        return $filter("isoCurrency")(data, full.currency);
                    }
                },
                {
                    "data": "discountCode",
                    "orderable": false
                },
                {
                    "data": "discountAmount",
                    "class": "text-right",
                    "orderable": false,
                    "render": function (data, _type, full) {
                        if (data !== 0)
                            return $filter("isoCurrency")(data, full.currency);
                        else
                            return "";
                    }
                },
                {
                    "data": "subtotal",
                    "class": "text-nowrap text-right",
                    "orderable": false,
                    "render": function (data, _type, full) {
                        return $filter("isoCurrency")(data, full.currency);
                    }
                },
                {
                    "data": "taxes",
                    "class": "text-nowrap text-right",
                    "orderable": false,
                    "render": function (data, _type, full) {
                        data = JSON.parse(data);
                        var taxes = "";
                        angular.forEach(data, function (tax) {
                            if (tax.Type === 'Exempt')
                                taxes += tax.Label;
                            else
                                taxes += tax.Label + ": " + $filter("isoCurrency")(tax.Amount, full.currency) + ", ";
                        });
                        return taxes.replace(/, +$/, "");
                    }
                },
                {
                    "data": "orderTotal",
                    "class": "text-nowrap text-right",
                    "orderable": false,
                    "render": function (data, _type, full) {
                        return $filter("isoCurrency")(data, full.currency);
                    }
                }
            ];
        }
    });
}());
